import { render, staticRenderFns } from "./benefitGroupsList.vue?vue&type=template&id=f0a8356c"
import script from "./benefitGroupsList.vue?vue&type=script&lang=js"
export * from "./benefitGroupsList.vue?vue&type=script&lang=js"
import style0 from "./benefitGroupsList.vue?vue&type=style&index=0&id=f0a8356c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports